import { HighlightedSearchWord } from './types';

const PartialHighlightedWord = ({
  partialHighlightWord,
  content,
  wordId
}: {
  partialHighlightWord: HighlightedSearchWord;
  content: string;
  wordId: number;
}) => {
  const prefix = content.substring(0, partialHighlightWord.highlightStart);
  const highlightedPart = content.substring(partialHighlightWord.highlightStart, partialHighlightWord.highlightEnd);
  const suffix =
    content.substring(partialHighlightWord.highlightEnd, content.length) +
    (!partialHighlightWord.highlightSpace ? ' ' : '');
  return (
    <>
      {prefix}
      <span className="bg-deep-orange text-white selection:bg-deep-orange" data-word-id={wordId}>
        {partialHighlightWord.highlightSpace ? highlightedPart + ' ' : highlightedPart}
      </span>
      {suffix}
    </>
  );
};

export default PartialHighlightedWord;
